import { ApprovalsReviewKind } from './constants';

export const getApprovalErrorNotificationMessage = (reviewKind: ApprovalsReviewKind) => {
  if (reviewKind === ApprovalsReviewKind.COMMENT) {
    return 'Failed to add comment. Try again later.';
  }

  return `Failed to ${reviewKind} request. Try again later.`;
};
